module.exports = __webpack_public_path__ + "06509258e6113e2e0e54592337ac8171.svg";